import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CandidateFormIdSelect } from './store';

@Injectable()
export class CandidateFormSelectResolver {
  constructor(private store: Store<{}>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> | void {
    this.store.dispatch(new CandidateFormIdSelect(route.params.id));
  }
}
